import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import './SpeedBuildings.module.css'; // Создадим этот файл стилей позже
import Banner from '../sections/Banner/Banner';
import SmallCards from '../../../components/CardsUI/SmallCards/SmallCards';
import BuildingPriceTable from '../../../components/Tables/BuildingPriceTable/BuildingPriceTable';
import ServicesDescription from '../../../components/EntToEndUI/ServicesDescription/ServicesDescription';
import { PhoneLineIcon, FileIcon, LadleIcon, CraneIcon } from '../../../components/Other/Icons/Icons';
import RequestForm from '../../../components/EntToEndUI/RequestForm/RequestForm';
import InfoGraphickBlock from '../sections/InfoGraphickBlock/InfoGraphickBlock';
import PageTitle from '../../../components/Other/PageTitle/PageTitle';

const SpeedBuildings = () => {
  const serviceType = 'speedbuildings'
  const { t } = useTranslation();
  const cards = [
    {
      title: 'АНГАРЫ И СЕЛЬСКОХОЗЯЙСТВЕННЫЕ КОМПЛЕКСЫ',
      image: '/images/cards/speedbuildings/1.png',
    },
    {
      title: 'СКЛАДЫ ПРОМЫШЛЕННОГО И БЫТОВОГО НАЗНАЧЕНИЯ',
      image: '/images/cards/speedbuildings/2.png',
    },
    {
      title: 'АДМИНИСТРАТИВНО-БЫТОВЫЕ КОРПУСА И ОФИСНЫЕ ЗДАНИЯ',
      image: '/images/cards/speedbuildings/3.png',
    },
    {
      title: 'ТОРГОВЫЕ ПАВИЛЬОНЫ И МАГАЗИНЫ',
      image: '/images/cards/speedbuildings/4.png',
    },
  ];

  const buildingPriceDataByWidth = {
    '12м': {
      columns: [30, 35, 40, 45, 50, 55],
      subHeader: "Длина, в м. / с шагом колонн 6м (чистовая высота здания - 5м)",
      rows: [
        {
          name: "МЕТАЛЛИЧЕСКИЙ(НЕСУЩИЙ) КАРКАС",
          clue: "Состав комплекта: колонны рядовые; колонны фахверковые; фермы покрытия; прогоны стеновые, кровельные; связи вертикальные, горизонтальные; элементы крепления, фасонные детали; комплект крепежей /болты, гайки, шайбы/; проектная документация /альбомы АС, КЖ, КМ, КМД/; паспорт качества; инструкция по монтажу.",
          prices: [2628840, 2965080, 3301320, 3637560, 3973920, 4310160]
        },
        {
          name: "СЭНДВИЧ-ПАНЕЛИ",
          clue: "Утеплитель - пенополистирол. Стена 100мм. Кровля 120мм.",
          prices: [3557280, 4023720, 4500960, 4970400, 5437080, 5883600]
        },
        {
          name: "УСТРОЙСТВО ФУНДАМЕНТА И Ж/Б ЦОКОЛЯ",
          clue: "Перечень работ: выемка грунта и обратная засыпка с послойным уплотнением, монтаж и демонтаж опалубки, монтаж армирующих каркасов и анкерных блоков, бетонирование /М300/, изоляция фундаментов битумной мастикой. Все материалы включены",
          prices: [1797480, 2003880, 2210280, 2416560, 2622960, 2829360]
        },
        {
          name: "УСТРОЙСТВО МОНОЛИТНОЙ(ЖЕЛЕЗОБЕТОННОЙ) ПЛИТЫ",
          clue: "Перечень работ: планировка грунта под основание, устройство песчаного основания с уплотнением /200мм/, устройство щебенчатого основания с уплотнением /100мм/, монтаж армирующих каркасов /дорожная сетка 100х100х4мм в два слоя/, бетонирование с применением виброрейки и устройством температурных швов /М250/. Все материалы включены.",
          prices: [1325640, 1548240, 1770840, 1993560, 2216160, 2414520]
        },
        {
          name: "МОНТАЖ МЕТАЛЛИЧЕСКОГО(НЕСУЩЕГО) КАРКАСА ЗДАНИЯ",
          clue: "Подъемные механизмы включены",
          prices: [489840, 550680, 611520, 686760, 747600, 808320]
        },
        {
          name: "МОНТАЖ СЭНДВИЧ-ПАНЕЛЕЙ",
          clue: "С доборными и фасонными элементами. Подъемные механизмы включены.",
          prices: [723840, 831240, 924360, 1031760, 1124880, 1218000]
        }
      ],
      totals: {
        sum: [10522920, 11922840, 13319280, 14736600, 16122600, 17463960],
        pricePerM2: [29230, 28388, 27749, 27290, 26871, 26461],
        area: [360, 420, 480, 540, 600, 660]
      }
    },
    '15м': {
      columns: [30, 35, 40, 45, 50, 55],
      subHeader: "Длина, в м. / с шагом колонн 6м (чистовая высота здания - 5м)",
      rows: [
        {
          name: "МЕТАЛЛИЧЕСКИЙ(НЕСУЩИЙ) КАРКАС",
          clue: "Состав комплекта: колонны рядовые; колонны фахверковые; фермы покрытия; прогоны стеновые, кровельные; связи вертикальные, горизонтальные; элементы крепления, фасонные детали; комплект крепежей /болты, гайки, шайбы/; проектная документация /альбомы АС, КЖ, КМ, КМД/; паспорт качества; инструкция по монтажу.",
          prices: [3023166, 3409842, 3796518, 4183194, 4570008, 4956684]
        },
        {
          name: "СЭНДВИЧ-ПАНЕЛИ",
          clue: "Утеплитель - пенополистирол. Стена 100мм. Кровля 120мм.",
          prices: [4090872, 4627278, 5176104, 5715960, 6252642, 6766140]
        },
        {
          name: "УСТРОЙСТВО ФУНДАМЕНТА И Ж/Б ЦОКОЛЯ",
          clue: "Перечень работ: выемка грунта и обратная засыпка с послойным уплотнением, монтаж и демонтаж опалубки, монтаж армирующих каркасов и анкерных блоков, бетонирование /М300/, изоляция фундаментов битумной мастикой. Все материалы включены",
          prices: [2067102, 2304462, 2541822, 2779044, 3016404, 3253764]
        },
        {
          name: "УСТРОЙСТВО МОНОЛИТНОЙ(ЖЕЛЕЗОБЕТОННОЙ) ПЛИТЫ",
          clue: "Перечень работ: планировка грунта под основание, устройство песчаного основания с уплотнением /200мм/, устройство щебенчатого основания с уплотнением /100мм/, монтаж армирующих каркасов /дорожная сетка 100х100х4мм в два слоя/, бетонирование с применением виброрейки и устройством температурных швов /М250/. Все материалы включены.",
          prices: [1524486, 1780476, 2036466, 2292594, 2548584, 2776698]
        },
        {
          name: "МОНТАЖ МЕТАЛЛИЧЕСКОГО(НЕСУЩЕГО) КАРКАСА ЗДАНИЯ",
          clue: "Подъемные механизмы включены",
          prices: [563316, 633282, 703248, 789774, 859740, 929568]
        },
        {
          name: "МОНТАЖ СЭНДВИЧ-ПАНЕЛЕЙ",
          clue: "С доборными и фасонными элементами. Подъемные механизмы включены.",
          prices: [832416, 956426, 1063014, 1186524, 1293612, 1400700]
        }
      ],
      totals: {
        sum: [12101358, 13711766, 15317172, 16947090, 18540990, 20083554],
        pricePerM2: [33615, 32647, 31911, 31383, 30902, 30429],
        area: [360, 420, 480, 540, 600, 660]
      }
    },
    '18м': {
      columns: [30, 35, 40, 45, 50, 55],
      subHeader: "Длина, в м. / с шагом колонн 6м (чистовая высота здания - 5м)",
      rows: [
        {
          name: "МЕТАЛЛИЧЕСКИЙ(НЕСУЩИЙ) КАРКАС",
          clue: "Состав комплекта: колонны рядовые; колонны фахверковые; фермы покрытия; прогоны стеновые, кровельные; связи вертикальные, горизонтальные; элементы крепления, фасонные детали; комплект крепежей /болты, гайки, шайбы/; проектная документация /альбомы АС, КЖ, КМ, КМД/; паспорт качества; инструкция по монтажу.",
          prices: [3476641, 3921318, 4365996, 4810673, 5255509, 5700187]
        },
        {
          name: "СЭНДВИЧ-ПАНЕЛИ",
          clue: "Утеплитель - пенополистирол. Стена 100мм. Кровля 120мм.",
          prices: [4704503, 5321370, 5952520, 6573354, 7190538, 7781061]
        },
        {
          name: "УСТРОЙСТВО ФУНДАМЕНТА И Ж/Б ЦОКОЛЯ",
          clue: "Перечень работ: выемка грунта и обратная засыпка с послойным уплотнением, монтаж и демонтаж опалубки, монтаж армирующих каркасов и анкерных блоков, бетонирование /М300/, изоляция фундаментов битумной мастикой. Все материалы включены",
          prices: [2377167, 2650131, 2923095, 3195900, 3468865, 3741829]
        },
        {
          name: "УСТРОЙСТВО МОНОЛИТНОЙ(ЖЕЛЕЗОБЕТОННОЙ) ПЛИТЫ",
          clue: "Перечень работ: планировка грунта под основание, устройство песчаного основания с уплотнением /200мм/, устройство щебенчатого основания с уплотнением /100мм/, монтаж армирующих каркасов /дорожная сетка 100х100х4мм в два слоя/, бетонирование с применением виброрейки и устройством температурных швов /М250/. Все материалы включены.",
          prices: [1753159, 2047547, 2341936, 2636483, 2930872, 3193203]
        },
        {
          name: "МОНТАЖ МЕТАЛЛИЧЕСКОГО(НЕСУЩЕГО) КАРКАСА ЗДАНИЯ",
          clue: "Подъемные механизмы включены",
          prices: [647813, 728274, 808735, 908240, 988701, 1069003]
        },
        {
          name: "МОНТАЖ СЭНДВИЧ-ПАНЕЛЕЙ",
          clue: "С доборными и фасонными элементами. Подъемные механизмы включены.",
          prices: [957278, 1099890, 1222466, 1364503, 1487654, 1610805]
        }
      ],
      totals: {
        sum: [13916562, 15768531, 17614748, 19489154, 21321139, 23096087],
        pricePerM2: [38657, 37544, 36697, 36091, 35535, 34994],
        area: [360, 420, 480, 540, 600, 660]
      }
    },
    '21м': {
      columns: [30, 35, 40, 45, 50, 55],
      subHeader: "Длина, в м. / с шагом колонн 6м (чистовая высота здания - 5м)",
      rows: [
        {
          name: "МЕТАЛЛИЧЕСКИЙ(НЕСУЩИЙ) КАРКАС",
          clue: "Состав комплекта: колонны рядовые; колонны фахверковые; фермы покрытия; прогоны стеновые, кровельные; связи вертикальные, горизонтальные; элементы крепления, фасонные детали; комплект крепежей /болты, гайки, шайбы/; проектная документация /альбомы АС, КЖ, КМ, КМД/; паспорт качества; инструкция по монтажу.",
          prices: [3998137, 4509516, 5020895, 5532274, 6043835, 6555215]
        },
        {
          name: "СЭНДВИЧ-ПАНЕЛИ",
          clue: "Утеплитель - пенополистирол. Стена 100мм. Кровля 120мм.",
          prices: [5410179, 6119576, 6845398, 7559357, 8269119, 8948220]
        },
        {
          name: "УСТРОЙСТВО ФУНДАМЕНТА И Ж/Б ЦОКОЛЯ",
          clue: "Перечень работ: выемка грунта и обратная засыпка с послойным уплотнением, монтаж и демонтаж опалубки, монтаж армирующих каркасов и анкерных блоков, бетонирование /М300/, изоляция фундаментов битумной мастикой. Все материалы включены",
          prices: [2733742, 3047651, 3361559, 3675285, 3989194, 4303103]
        },
        {
          name: "УСТРОЙСТВО МОНОЛИТНОЙ(ЖЕЛЕЗОБЕТОННОЙ) ПЛИТЫ",
          clue: "Перечень работ: планировка грунта под основание, устройство песчаного основания с уплотнением /200мм/, устройство щебенчатого основания с уплотнением /100мм/, монтаж армирующих каркасов /дорожная сетка 100х100х4мм в два слоя/, бетонирование с применением виброрейки и устройством температурных швов /М250/. Все материалы включены.",
          prices: [2016133, 2354679, 2693226, 3031955, 3370502, 3672183]
        },
        {
          name: "МОНТАЖ МЕТАЛЛИЧЕСКОГО(НЕСУЩЕГО) КАРКАСА ЗДАНИЯ",
          clue: "Подъемные механизмы включены",
          prices: [744985, 837515, 930045, 1044476, 1137006, 1229353]
        },
        {
          name: "МОНТАЖ СЭНДВИЧ-ПАНЕЛЕЙ",
          clue: "С доборными и фасонными элементами. Подъемные механизмы включены.",
          prices: [1100870, 1264874, 1405836, 1569178, 1710802, 1852426]
        }
      ],
      totals: {
        sum: [16004046, 18133811, 19256959, 22412525, 24520458, 26560500],
        pricePerM2: [44456, 43176, 42202, 41505, 40867, 40243],
        area: [360, 420, 480, 540, 600, 660]
      }
    },
    '24м': {
      columns: [30, 35, 40, 45, 50, 55],
      subHeader: "Длина, в м. / с шагом колонн 6м (чистовая высота здания - 5м)",
      rows: [
        {
          name: "МЕТАЛЛИЧЕСКИЙ(НЕСУЩИЙ) КАРКАС",
          clue: "Состав комплекта: колонны рядовые; колонны фахверковые; фермы покрытия; прогоны стеновые, кровельные; связи вертикальные, горизонтальные; элементы крепления, фасонные детали; комплект крепежей /болты, гайки, шайбы/; проектная документация /альбомы АС, КЖ, КМ, КМД/; паспорт качества; инструкция по монтажу.",
          prices: [4597858, 5185944, 5774029, 6362115, 6950410, 7538497]
        },
        {
          name: "СЭНДВИЧ-ПАНЕЛИ",
          clue: "Утеплитель - пенополистирол. Стена 100мм. Кровля 120мм.",
          prices: [6221706, 7037512, 7872208, 8693261, 9509487, 10290453]
        },
        {
          name: "УСТРОЙСТВО ФУНДАМЕНТА И Ж/Б ЦОКОЛЯ",
          clue: "Перечень работ: выемка грунта и обратная засыпка с послойным уплотнением, монтаж и демонтаж опалубки, монтаж армирующих каркасов и анкерных блоков, бетонирование /М300/, изоляция фундаментов битумной мастикой. Все материалы включены",
          prices: [3143803, 3504799, 3865793, 4226578, 4587573, 4948568]
        },
        {
          name: "УСТРОЙСТВО МОНОЛИТНОЙ(ЖЕЛЕЗОБЕТОННОЙ) ПЛИТЫ",
          clue: "Перечень работ: планировка грунта под основание, устройство песчаного основания с уплотнением /200мм/, устройство щебенчатого основания с уплотнением /100мм/, монтаж армирующих каркасов /дорожная сетка 100х100х4мм в два слоя/, бетонирование с применением виброрейки и устройством температурных швов /М250/. Все материалы включены.",
          prices: [2318553, 2707881, 3097210, 3486748, 3876077, 4223010]
        },
        {
          name: "МОНТАЖ МЕТАЛЛИЧЕСКОГО(НЕСУЩЕГО) КАРКАСА ЗДАНИЯ",
          clue: "Подъемные механизмы включены",
          prices: [856733, 963142, 1069552, 1201148, 1307557, 1413756]
        },
        {
          name: "МОНТАЖ СЭНДВИЧ-ПАНЕЛЕЙ",
          clue: "С доборными и фасонными элементами. Подъемные механизмы включены.",
          prices: [1266001, 1454605, 1616711, 1804555, 1967422, 2130290]
        }
      ],
      totals: {
        sum: [18404654, 20853883, 23295503, 25774405, 28198526, 30544574],
        pricePerM2: [51124, 49652, 48532, 47730, 46997, 46279],
        area: [360, 420, 480, 540, 600, 660]
      }
    }
  };

  const items = [
    {
      icon: <PhoneLineIcon />,
      description: t('services.speedbuildings.info.phone')
    },
    {
      icon: <FileIcon />,
      description: t('services.speedbuildings.info.file')
    },
    {
      icon: <LadleIcon />,
      description: t('services.speedbuildings.info.ladle')
    },
    {
      icon: <CraneIcon />,
      description: t('services.speedbuildings.info.crane')
    }
  ];

  const [selectedWidth, setSelectedWidth] = useState('12м');
  
  // Теперь просто берем нужные данные из объекта по ключу
  const currentPriceData = buildingPriceDataByWidth[selectedWidth];

  const handleWidthChange = (width) => {
    setSelectedWidth(width);
    // Данные обновятся автоматически, так как изменится selectedWidth
  };

  return (
    <div className="service-page">
      <PageTitle title={t('services.speedbuildings.title')} />
        <Banner serviceType={serviceType} Image={'/images/cards/speedbuildings/speedbuildings.png'}/>
        <SmallCards cards={cards}/>
        <InfoGraphickBlock
            title={t('services.speedbuildings.infograph_title')}
            subTitle={t('services.speedbuildings.infograph_subtitle')}
            image={'/images/speedbuildings_infograph.png'}
        />
        <BuildingPriceTable
            data={currentPriceData}
            title={t('services.speedbuildings.table.title')}
            subtitle={t('services.speedbuildings.table.subtitle')}
            warning={t('services.speedbuildings.table.warning')}
            onWidthChange={handleWidthChange}
            selectedWidth={selectedWidth}
            infoText={t('services.speedbuildings.table.buttonText')}
            buttonText={t('header.orderButton')}
            buttonLink={t('services.speedbuildings.table.buttonLink')}
        />
        <ServicesDescription items={items} />
        <RequestForm />
    </div>
  );
};

export default SpeedBuildings; 